<template>
  <div class="result-page">
    <div class="main">
      <div class="search-result">
        <filter-component :keyword="keyword" :size='size' :type="type" :time="time" :searchtype="searchtype"/>
        <template v-if="!loading">
          <div class="result-inner" v-if="results.length > 0">
            <p class="tip">
              <span>共搜索出 <span class="em">{{ total }}</span> 条结果。</span> 
              </p>
            <div class="result-wrap">
              <template v-for="(item, index) in results">
                <resource-item 
                  v-if="keywordAdData && index == keywordAdConfig.index"
                  :data="keywordAdData" 
                  :keyword="keyword" 
                  :subscribed="true"
                  :key="`ad-${item.res.filename}-${index}`" 
                />
                <resource-item 
                  :data="item" 
                  :keyword="keyword" 
                  :subscribed="isLogin"
                  @login="showLogin"
                  :key="`search-${item.res.filename}-${index}`" 
                />
              </template>
            </div>
            <pager :pageCurrent="page" :pageTotal="`${Math.ceil(total/30)}`" :keyword="keyword"/>
          </div>
          <div class="sensitive" v-if="data === 'toomuch'">
            <img src="@/assets/images/error.png"  class="none-image" alt="您的搜索过于频繁，建议稍后尝试！">
            <p class="none-tip">您的搜索过于频繁，建议稍后尝试！</p>
          </div>
          <div class="sensitive" v-if="data === 'limited'">
            <img src="@/assets/images/error.png"  class="none-image" alt="当前访问人数过多，请稍后重试!">
            <p class="none-tip">当前访问人数过多，请稍后重试!</p>
            <div class="hot-wrap">
              <p class="none-tip">试试下面的热搜词</p>
              <hot />
            </div>
          </div>
          <div class="sensitive" v-if="data === 'blocked'">
            <img src="@/assets/images/error.png" class="none-image" alt="当前IP禁止访问，如有疑问，请点击右下角留言反馈"> 
            <p class="none-tip">当前IP禁止访问，若需要解封，请点击右下角留言反馈。</p>
            <p class="none-tip">请登录账号后继续访问(未登录用户限制访问频次)</p>
            <p class="none-tip">如你觉得判断有问题可以<a href="http://alibabachanpinjingliwenjuan.mikecrm.com/MqvKfCW" target="_blank">->点此在线反馈问题</a></p>
            <div class="hot-wrap">
              <p class="none-tip">试试下面的热搜词</p>
              <hot />
            </div>
          </div>
          <div class="sensitive" v-if="data==='politics'  || data==='porn'  || data==='contraband'  || data==='terrorism'  || data==='privacy'">
            <p class="none-tip">你搜索的 <span class="em">『{{keyword}}』</span> 包含违禁词，请文明搜索！</p>
            <p class="none-tip">如你觉得判断有问题可以<a href="http://alibabachanpinjingliwenjuan.mikecrm.com/MqvKfCW" target="_blank">->点此在线反馈问题</a></p>
            <div class="hot-wrap">
              <p class="none-tip">试试下面的热搜词</p>
              <hot />
            </div>
          </div>
          <div class="sensitive" v-if="results.length == 0 && !data">
            <img src="@/assets/images/error.png" class="none-image">
            <p class="none-tip" v-if="results.length == 0 && keyword">服务器线路忙，请稍后重试，也可以尝试其他线路访问！<br>注：免费线路长期无偿为大家使用，能力有限，还请见谅！</p>
            <div class="hot-wrap">
              <p class="none-tip">试试下面的热搜词</p>
              <hot />
            </div>
          </div>
          <div class="sensitive" v-if="results.length == 0 && data && data.resources === null">
            <img src="@/assets/images/error.png" class="none-image">
            <p class="none-tip" v-if="results.length == 0 && keyword" >没有搜到 <span class="em">『{{keyword}}』</span> 的任何结果，切换 `『模糊搜索』` 搜一搜。</p>
            <p class="none-tip" v-if="results.length == 0 && !keyword">关键词为空，请输入关键词进行搜索。</p>
            <div class="hot-wrap">
              <p class="none-tip">试试下面的热搜词</p>
              <hot />
            </div>
          </div>
        </template>
        
        <div class="loading-wrap" v-if="loading">
          <van-loading size="40px" color="#cb8807" vertical>资源搜索中...</van-loading>
        </div>
      </div>
      <!-- <ad />  -->
    </div>
  </div>
</template>

<script>
// import Ad from '@/components/Ad'
import Hot from '@/components/Hot'
import Pager from '@/components/PagerNew'
import FilterComponent from '@/components/Filter'
import ResourceItem from '@/components/ResourceItem'
import { getSearchResult, getKeywordAdsInfo } from '@/api/search'
import { isWeixin, isMobile, isIOS, isAndroid } from '@/utils/navigator'
import getFileType from '@/utils/getFileType'

export default {
  data () {
    return {
      url: '',
      data: null,
      size: -1,
      type: -1,
      time: -1,
      searchtype: -1,
      page: 1,
      total: 0,
      results: [],
    keyword: '',
      loading: true,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      isIOS: isIOS(),
      isAndroid: isAndroid(),
      keywordAdConfig: null,
      keywordAdData: null,
    }
  },
  watch: {
    '$route': function (to) {
      this.setRoute(to.query)
      this.refresh()
      if (this.$refs.page) {
        this.$refs.page.scrollTop = 0
      }
    }
  },
  async mounted () {
     this.setRoute(this.$route.query)
    await this.refresh()
    this.keywordAdConfig = await getKeywordAdsInfo()
    if (
        this.keywordAdConfig && this.keywordAdConfig.display
        && this.keywordAdConfig.data
        && this.keywordAdConfig.data.length > 0 
        && (
          this.keywordAdConfig.keyword === '' || this.keywordAdConfig.keyword.lastIndexOf(this.keyword) > -1
        )
        && (
          this.isWeixin === this.keywordAdConfig.isWeixin || this.keywordAdConfig.isWeixin === ''
        ) 
        && (
          this.isMobile === this.keywordAdConfig.isMobile || this.keywordAdConfig.isMobile === ''
        )
      ) 
    {
      const data = this.keywordAdConfig.data
      this.keywordAdData = data[Math.floor(Math.random() * data.length)]
    }
  },
  methods: {
    setRoute (query) {
      const { kw, keyword, page = 1, size, type, time, searchtype } = query
      this.size = size
      this.type = type
      this.time = time
      this.page = parseInt(page)
      this.keyword = kw || keyword
      this.searchtype = searchtype
    },
    async refresh () {
      this.loading = true
      let data = null
      data = await getSearchResult({ 
        page: this.page, 
        size: this.size, 
        type: this.type, 
        time: this.time, 
        line: this.searchWay,
        keyword: this.keyword, 
        searchtype: this.searchtype,
      })
      this.loading = false
      this.data = data
      if (data && data.resources) {
        this.total = data.total
        this.results = data.resources.map((item) => {
          item.res.fileType = item.res.isdir !== 1 ? getFileType(`test.${item.res.ext}`) : 'filetype_folder'
          return item
        })
      }  else if (data && data.resources === null && data.total === 0 && this.searchtype == undefined || this.searchtype == -1) {
        this.$toast('正在切换至模糊搜索')
        this.$store.commit('changeFilterSearchType', 1)
        this.$router.push({ path: '/main/search', query: { keyword: this.keyword, searchtype: 1 } })
      } else {
        this.results = []
        this.total = 0
      }
    },
    showLogin () {
      this.showLoginDialog()
    }
  },
  components: {
    FilterComponent,
    ResourceItem,
    Pager,
    Hot,
    // Ad
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_var.scss";
.result-page {
  background-color: #f8f8f8;
  min-height: 100%;
}
.main {
  width: 1060px;
  max-width: 100%;
  padding: 20px 0;
  margin: 0 auto;
  display: flex;
  // justify-content: space-between;
  justify-content: center;
}
.search-result {
  width: 800px;
  max-width: 100%;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 30px;
  .sensitive {
    text-align: center;
    .none-image {
      width: 200px;
    }
    .none-tip {
      margin-top: 20px;
      font-size: 16px;
      margin-bottom: 10px;
      .em {
        color: $theme-color;
      }
    }
    .hot-wrap {
      margin-top: 30px;
      .none-tip {
        font-weight: bold;
        margin-bottom: 15px;
      }
    }
  }
  .tip {
    font-size: 14px;
    margin-bottom: 10px;
    .em {
      color: $theme-color;
      font-weight: bold;
    }
  }

  .loading-wrap {
    padding-top: 30px;
  }
}

@media (max-width: 700px) {
  .main {
    margin-top: 10px;
    margin: 0;
  }
  .search-result {
    padding: 15px;
    .google-feed-ad {
      padding: 10px 0;
    }
  }
}
</style>
